import ActiveRecord from './active_record/base'

class Operation extends ActiveRecord {
	static tableName = 'operations'
	static defaultJoins = ['environments']
}

export default Operation
